import auth from '../auth';
import * as retryer from './retryer';

const bindings = new Map();
const sources = new Map();

const getHandlers = e => bindings.get(e) || bindings.set(e, new Set()) && bindings.get(e);
const addHandler = (e, fn) => getHandlers(e).add(fn);
const deleteHandler = (e, fn) => getHandlers(e).delete(fn);
const trigger = (e, ...args) => getHandlers(e).forEach(fn => setTimeout(fn, 0, ...args));

function authWithEvents(authUrl) {
  return auth.getToken().then(token => {
    return fetch(authUrl.href, {
      method: 'POST',
      credentials: 'include',
      headers: {
        Authorization: `Bearer ${token}`
      }
    });
  }).then(res => {
    if (!res.ok) {
      throw new Error('Problem authing with events');
    }
  });
}

function listen(opts) {
  const authUrl = new URL('/v2/auth', window.env.EVENTS_URL);
  const streamUrl = new URL(`/v2/stream/deck/${opts.deckId}`, window.env.EVENTS_URL);

  retryer.wrap((retry, reset) => {
    authWithEvents(authUrl).then(() => {
      let eventSource = new window.EventSource(streamUrl.href, {
        withCredentials: true
      });
      let interval;

      sources.set(opts.deckId, eventSource);

      eventSource.onerror = function (event) {
        if (interval) {
          clearInterval(interval);
        }
        eventSource.close();
        eventSource = null;
        trigger('error', event);
        retry();
      };

      eventSource.onopen = function () {
        reset();
        trigger('open');

        let lastTime = Date.now();

        // When chrome has an open EventSource connection and the
        // machine goes to sleep, the connection will no longer receive
        // events and no error will be thrown. This attempts to detect
        // such an occurrence and replace the connection when it
        // happens.
        // https://bugs.chromium.org/p/chromium/issues/detail?id=225654#
        interval = setInterval(() => {
          const currentTime = Date.now();

          if (currentTime > lastTime + 2000) {
            eventSource.close();
            clearInterval(interval);
            listen(opts);
          }

          lastTime = currentTime;
        }, 1000);
      };

      bindings.forEach((handlers, eventName) => {
        eventSource.addEventListener(eventName, event => {
          if (event.data === '0') {
            return handlers.forEach(handler => setTimeout(handler, 0));
          }

          let data;

          try {
            data = JSON.parse(event.data);
          } catch (err) {
            trigger('error', err);
          }

          return handlers.forEach(handler => setTimeout(handler, 0, data));
        });
      });
    }).catch(err => {
      trigger('error', err);
      retry();
    });
  });
}

function unlisten(opts) {
  if (!sources.has(opts.deckId)) {
    return;
  }

  const eventSource = sources.get(opts.deckId);

  eventSource.close();
}

export default {
  listen,

  unlisten,

  on(eventName, handler) {
    addHandler(eventName, handler);
  },

  off(eventName, handler) {
    deleteHandler(eventName, handler);
  },

  offAll() {
    bindings.clear();
  },

  trigger(eventName, ...args) {
    trigger(eventName, ...args);
  }
};
